export const swalModals = {
  methods: {
    swalUnsavedChanges() {
      return this.$swal({
        title: 'Weet je het zeker?',
        text: 'Je hebt aanpassingen die niet zijn opgeslagen!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ja, sla niet op!',
        cancelButtonText: 'Annuleren',
        reverseButtons: true
      })
    },
    swalDelete(value) {
      return this.$swal({
        title: 'Weet je het zeker?',
        html: 'Wilt u <strong>' + value + '</strong> echt verwijderen? Dit proces kan niet ongedaan worden gemaakt',
        type: 'error',
        confirmButtonText: 'Verwijderen',
        showCancelButton: true,
        cancelButtonText: 'Annuleren',
        reverseButtons: true
      })
    },
    swalDeleteAppointment(candidate, startDate, startTime, endTime, company) {
      return this.$swal({
        title: 'Weet je het zeker?',
        html: 'Wilt u de afspraak van <strong>' + candidate + '</strong> op <strong>' + startDate + '</strong> van <strong>' + startTime + '</strong> tot <strong>' + endTime + '</strong> bij <strong>' + company + '</strong> echt verwijderen? Dit proces kan niet ongedaan worden gemaakt',
        type: 'error',
        confirmButtonText: 'Verwijderen',
        showCancelButton: true,
        cancelButtonText: 'Annuleren',
        reverseButtons: true
      })
    },
    swalConfirmAction(text) {
      return this.$swal({
        title: 'Weet je het zeker?',
        text: text,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ja',
        cancelButtonText: 'Annuleren',
        reverseButtons: true
      })
    }
  }
}